// extracted by mini-css-extract-plugin
module.exports = {"managers":"managers__3kD9d","circle":"circle__1w8jc"};